export const DAILY_BONUS = 1;
export const DAILY_SPINS = 2;
export const REFER_A_FRIEND = 3;
export const BONUS = 5;
export const TICKET = 8;
